import { fetchReport } from '../functions/fetchReport';
import { fetchGameStages } from '../functions/stageReport';
import {
  getCompletedDaysForReveal,
  resolveNavigatePathFromProgress,
} from './gameStages';

export async function resolvePostSubmitNavigation({
  stageNumber,
  token,
  userId,
  organizationId,
  sessionId,
}) {
  const [stageData, reportResp] = await Promise.all([
    fetchGameStages({ token, userId, organizationId, sessionId }),
    fetchReport({ userId, token, sessionId, organizationId }),
  ]);

  return {
    path: resolveNavigatePathFromProgress(stageNumber, stageData, reportResp?.report),
    completedDaysForReveal: getCompletedDaysForReveal(
      stageData,
      reportResp?.report,
      stageNumber
    ),
  };
}
